import {Component, EventEmitter, Input, Output} from "@angular/core";
import {AppSearchFacets} from "../../../models/appSearch.model";
import {ActivatedRoute} from "@angular/router";
import {SwiperConfigInterface} from "ngx-swiper-wrapper";

@Component(
        {
            selector: 'catalogue-app-search-hierarchy-facets',
            templateUrl: './app-search-hierarchy-facets.component.html',
            styleUrls: [
                './app-search-hierarchy-facets.component.scss'
            ],
        }
)
export class AppSearchHierarchyFacetsComponent {
    @Input() public facets: AppSearchFacets[];
    @Output() public toggleFacetOption = new EventEmitter();

    constructor(
            private activatedRoute: ActivatedRoute
    ) {
    }

    get hierarchyFacets(): AppSearchFacets {
        for (let i = 1; i <= this.facets.length; i++) {
            if (!Object.keys(this.activatedRoute.snapshot.queryParams).includes('filters[product_hierarchy_level_' + i + '][]')) {
                return this.facets.find(
                        facetTypes => facetTypes.find(
                                facet => facet.cid === 'product_hierarchy_level_' + i
                        )
                );
            }
        }

        return [];
    }

    public catalogueCarouselConfig: SwiperConfigInterface = {
        speed: 320,
        direction: 'horizontal',
        slidesPerView: 4,
        spaceBetween: 8,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            },
            1400: {
                slidesPerView: 5,
            }
        }
    };

}
